import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const bonusBooks = [{
  src: 'https://cdn.magicpatterns.com/uploads/8hCkxvV695qrhWRJUeEp3V/Diseno_sin_titulo_(7).webp',
  alt: 'PLC MASTER',
  position: 'top-left' as const
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jMegiRm2EkcJHgkYsr55Yo/A_detailed,_premium_202604151029.png',
  alt: 'Variadores y Sensores',
  position: 'top-right' as const
}, {
  src: 'https://cdn.magicpatterns.com/uploads/urAD5W6FULjmkd4Bkb2VES/Diseno_sin_titulo_(7)_(2).webp',
  alt: 'Bono 3 Protocolo de Energía',
  position: 'bottom-left' as const
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vsVq8bhiUB6NysBrB8mjAQ/Diseno_sin_titulo_(7)_(1).webp',
  alt: 'Curso Paneles Solares',
  position: 'bottom-right' as const
}];
const positionConfig = {
  'top-left': {
    x: '-55%',
    y: '-22%',
    rotate: -6,
    z: 12
  },
  'top-right': {
    x: '55%',
    y: '-22%',
    rotate: 6,
    z: 11
  },
  'bottom-left': {
    x: '-60%',
    y: '18%',
    rotate: -4,
    z: 10
  },
  'bottom-right': {
    x: '60%',
    y: '18%',
    rotate: 4,
    z: 9
  }
};
export function BookStackFan() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start 0.85', 'center 0.45']
  });
  // Main book: scale down slightly for depth
  const mainScale = useTransform(scrollYProgress, [0, 1], [1, 0.92]);
  const mainY = useTransform(scrollYProgress, [0, 1], [0, -5]);
  // Bonus opacity (fade in as they fan out)
  const bonusOpacity = useTransform(scrollYProgress, [0, 0.3, 1], [0.3, 0.8, 1]);
  // Create transforms for each position
  const tlX = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['top-left'].x]);
  const tlY = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['top-left'].y]);
  const tlR = useTransform(scrollYProgress, [0, 1], [0, positionConfig['top-left'].rotate]);
  const trX = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['top-right'].x]);
  const trY = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['top-right'].y]);
  const trR = useTransform(scrollYProgress, [0, 1], [0, positionConfig['top-right'].rotate]);
  const blX = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['bottom-left'].x]);
  const blY = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['bottom-left'].y]);
  const blR = useTransform(scrollYProgress, [0, 1], [0, positionConfig['bottom-left'].rotate]);
  const brX = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['bottom-right'].x]);
  const brY = useTransform(scrollYProgress, [0, 1], ['0%', positionConfig['bottom-right'].y]);
  const brR = useTransform(scrollYProgress, [0, 1], [0, positionConfig['bottom-right'].rotate]);
  const transforms = [{
    x: tlX,
    y: tlY,
    rotate: tlR
  }, {
    x: trX,
    y: trY,
    rotate: trR
  }, {
    x: blX,
    y: blY,
    rotate: blR
  }, {
    x: brX,
    y: brY,
    rotate: brR
  }];
  return <div ref={containerRef} className="relative w-full flex items-center justify-center mb-10 mt-6" style={{
    perspective: '1200px',
    height: 'clamp(380px, 50vw, 520px)'
  }} data-id="element-10">
      {/* Ambient glow behind the stack */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px] h-[320px] md:w-[420px] md:h-[420px] bg-blue-500/20 rounded-full blur-[100px] pointer-events-none" data-id="element-11" />

      {/* Bonus books (behind main) */}
      {bonusBooks.map((book, i) => <motion.img key={book.position} src={book.src} alt={book.alt} loading="lazy" decoding="async" className="absolute w-[180px] md:w-[240px] h-auto object-contain select-none pointer-events-none" style={{
      x: transforms[i].x,
      y: transforms[i].y,
      rotate: transforms[i].rotate,
      opacity: bonusOpacity,
      zIndex: positionConfig[book.position].z,
      filter: 'drop-shadow(0 15px 35px rgba(0,0,0,0.6))'
    }} data-id="element-12" />)}

      {/* Main Book — Maestro Eléctrico (top layer) */}
      <motion.img src="https://cdn.magicpatterns.com/uploads/fMZ5Fq5SNbxYwzfww2mdPS/Diseno_sin_titulo_(1).webp" alt="Maestro Eléctrico" loading="lazy" decoding="async" className="absolute w-[260px] md:w-[330px] h-auto object-contain select-none pointer-events-none" style={{
      scale: mainScale,
      y: mainY,
      zIndex: 20,
      filter: 'drop-shadow(0 25px 50px rgba(0,0,0,0.55)) drop-shadow(0 5px 15px rgba(59,130,246,0.2))'
    }} data-id="element-13" />

      {/* Subtle label under the stack */}
      <motion.p style={{
      opacity: bonusOpacity
    }} className="absolute bottom-0 left-1/2 -translate-x-1/2 text-[11px] md:text-xs text-blue-300/60 font-medium uppercase tracking-widest whitespace-nowrap" data-id="element-14">
        1 Manual Principal + 5 Bonos Técnicos
      </motion.p>
    </div>;
}